// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
.section__container {
  max-width: 1200px;
  margin: auto;
  padding: 5rem 1rem;
}

.section__subheader {
  position: relative;
  isolation: isolate;
  margin-bottom: 1rem;
  padding-left: 5rem;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 2px;
  color: #e9c675;
}

.section__subheader::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 2px;
  width: 4rem;
  background-color: #e9c675;
}

.section__subheader::after {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-60%, -50%);
  font-size: 8rem;
  font-weight: 600;
  color: #ffffff;
  opacity: 0.1;
  z-index: -1;
}

.section__header {
  margin-bottom: 1rem;
  font-size: 3rem;
  font-weight: 400;
  color: #ffffff;
}

/*.btn {*/
/*    padding: 0.75rem 1.5rem;*/
/*    outline: none;*/
/*    border: none;*/
/*    display: flex;*/
/*    align-items: center;*/
/*    gap: 10px;*/
/*    font-size: 1rem;*/
/*    color: #ffffff;*/
/*    background-color: transparent;*/
/*    border-radius: 5px;*/
/*    transition: 0.3s;*/
/*    cursor: pointer;*/
/*}*/

/*.btn:hover {*/
/*    background-color: rgba(10, 30, 39, 0.5);*/
/*}*/

/*.logo a {*/
/*    font-size: 1.5rem;*/
/*    font-weight: 600;*/
/*    color: #ffffff;*/
/*}*/

/*img {*/
/*    display: flex;*/
/*    width: 100%;*/
/*}*/

/*a {*/
/*    text-decoration: none;*/
/*    transition: 0.3s;*/
/*}*/

/*html,*/
/*body {*/
/*    scroll-behavior: smooth;*/
/*}*/

/*body {*/
/*    font-family: "Poppins", sans-serif;*/
/*}*/

.header__container {
  position: relative;
  isolation: isolate;
  height: calc(100% - 75px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header__content {
  max-width: 700px;
}

.header__content .section__header {
  font-size: 4rem;
  font-weight: 600;
  line-height: 5rem;
}

.header__content a {
  color: #ffffff;
}

.header__content a:hover {
  color: #e9c675;
}

.header__socials {
  position: absolute;
  left: 0;
  align-items: center;
  gap: 1rem;
  color: #ffffff;
  transform: translateX(calc(-50% + 1rem)) rotate(90deg);
  display: none;
}

.header__socials a {
  font-size: 1.2rem;
  color: #ffffff;
  transform: rotate(-90deg);
}

.header__socials a:hover {
  color: #e9c675;
}

.about {
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #0a1e27 8rem);
  overflow: hidden;
}

.about__container {
  padding-top: 0;
  display: grid;
  gap: 5rem 2rem;
  overflow: hidden;
}

.about__image img {
  max-width: 400px;
  margin-inline: auto;
  border-radius: 5px;
  box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.4);
}

.about__content-1 .section__subheader::after {
  content: "D1";
}

.about__content-2 .section__subheader::after {
  content: "D2";
}

.about__content-3 .section__subheader::after {
  content: "D3";
}
.about__content-4 .section__subheader::after {
  content: "D4";
}
.about__content-5 .section__subheader::after {
  content: "D5";
}
.about__content-6 .section__subheader::after {
  content: "D6";
}
.about__content-7 .section__subheader::after {
  content: "07";
}
.about__content-8 .section__subheader::after {
  content: "08";
}
.about__content-9 .section__subheader::after {
  content: "09";
}
.about__content-10 .section__subheader::after {
  content: "10";
}

.about__content p {
  margin-bottom: 1.5rem;
  color: #cbd5e1;
}

.about__content a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #e9c675;
}

.about__content a span {
  transition: 0.3s;
}

.about__content a:hover span {
  transform: translateX(10px);
}

.footer {
  background-color: var(--yellow);
}

.footer__container {
  display: grid;
  gap: 4rem 2rem;
}

.footer__col:first-child {
  max-width: 300px;
}

.footer__logo {
  margin-bottom: 1rem;
}

.footer__col p {
  color: #cbd5e1;
}

.footer__col h4 {
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: #e9c675;
}

.footer__links {
  list-style: none;
  display: grid;
  gap: 1rem;
}

.footer__links a {
  color: #cbd5e1;
}

.footer__links a:hover {
  color: #e9c675;
}

.footer__bar {
  padding: 1rem;
  font-size: 0.9rem;
  color: #cbd5e1;
  text-align: center;
}

@media (width > 768px) {
  .nav__logo {
    flex: 1;
  }

  .nav__links {
    position: static;
    padding: 0;
    display: flex;
    flex-direction: row;
    background-color: transparent;
  }

  .nav__menu__btn {
    display: none;
  }

  .nav__action__btn {
    justify-content: flex-end;
    display: flex;
    flex: 1;
  }

  .header__container {
    height: calc(100% - 10rem);
  }

  .header__socials {
    display: flex;
  }

  .about__container {
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 10rem 2rem;
  }

  .about__image-1 {
    grid-area: 1/2/2/3;
  }

  .about__image-3 {
    grid-area: 3/2/4/3;
  }

  .about__image-5 {
    grid-area: 5/2/6/3;
  }

  .about__image-7 {
    grid-area: 7/2/8/3;
  }

  .about__content {
    margin-left: 6rem;
  }

  .footer__container {
    grid-template-columns: 2fr 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/TourRoute/TourRoute.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,SAAS;AACT,+BAA+B;AAC/B,qBAAqB;AACrB,oBAAoB;AACpB,qBAAqB;AACrB,2BAA2B;AAC3B,iBAAiB;AACjB,uBAAuB;AACvB,sBAAsB;AACtB,qCAAqC;AACrC,0BAA0B;AAC1B,wBAAwB;AACxB,uBAAuB;AACvB,IAAI;;AAEJ,eAAe;AACf,+CAA+C;AAC/C,IAAI;;AAEJ,YAAY;AACZ,yBAAyB;AACzB,wBAAwB;AACxB,sBAAsB;AACtB,IAAI;;AAEJ,QAAQ;AACR,qBAAqB;AACrB,mBAAmB;AACnB,IAAI;;AAEJ,MAAM;AACN,6BAA6B;AAC7B,wBAAwB;AACxB,IAAI;;AAEJ,QAAQ;AACR,SAAS;AACT,+BAA+B;AAC/B,IAAI;;AAEJ,SAAS;AACT,0CAA0C;AAC1C,IAAI;;AAEJ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,sDAAsD;EACtD,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,OAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;EACpC;AACF","sourcesContent":["/**\n * Copyright 2025 Paion Data. All rights reserved.\n */\n.section__container {\n  max-width: 1200px;\n  margin: auto;\n  padding: 5rem 1rem;\n}\n\n.section__subheader {\n  position: relative;\n  isolation: isolate;\n  margin-bottom: 1rem;\n  padding-left: 5rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  letter-spacing: 2px;\n  color: #e9c675;\n}\n\n.section__subheader::before {\n  position: absolute;\n  content: \"\";\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  height: 2px;\n  width: 4rem;\n  background-color: #e9c675;\n}\n\n.section__subheader::after {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate(-60%, -50%);\n  font-size: 8rem;\n  font-weight: 600;\n  color: #ffffff;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.section__header {\n  margin-bottom: 1rem;\n  font-size: 3rem;\n  font-weight: 400;\n  color: #ffffff;\n}\n\n/*.btn {*/\n/*    padding: 0.75rem 1.5rem;*/\n/*    outline: none;*/\n/*    border: none;*/\n/*    display: flex;*/\n/*    align-items: center;*/\n/*    gap: 10px;*/\n/*    font-size: 1rem;*/\n/*    color: #ffffff;*/\n/*    background-color: transparent;*/\n/*    border-radius: 5px;*/\n/*    transition: 0.3s;*/\n/*    cursor: pointer;*/\n/*}*/\n\n/*.btn:hover {*/\n/*    background-color: rgba(10, 30, 39, 0.5);*/\n/*}*/\n\n/*.logo a {*/\n/*    font-size: 1.5rem;*/\n/*    font-weight: 600;*/\n/*    color: #ffffff;*/\n/*}*/\n\n/*img {*/\n/*    display: flex;*/\n/*    width: 100%;*/\n/*}*/\n\n/*a {*/\n/*    text-decoration: none;*/\n/*    transition: 0.3s;*/\n/*}*/\n\n/*html,*/\n/*body {*/\n/*    scroll-behavior: smooth;*/\n/*}*/\n\n/*body {*/\n/*    font-family: \"Poppins\", sans-serif;*/\n/*}*/\n\n.header__container {\n  position: relative;\n  isolation: isolate;\n  height: calc(100% - 75px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header__content {\n  max-width: 700px;\n}\n\n.header__content .section__header {\n  font-size: 4rem;\n  font-weight: 600;\n  line-height: 5rem;\n}\n\n.header__content a {\n  color: #ffffff;\n}\n\n.header__content a:hover {\n  color: #e9c675;\n}\n\n.header__socials {\n  position: absolute;\n  left: 0;\n  align-items: center;\n  gap: 1rem;\n  color: #ffffff;\n  transform: translateX(calc(-50% + 1rem)) rotate(90deg);\n  display: none;\n}\n\n.header__socials a {\n  font-size: 1.2rem;\n  color: #ffffff;\n  transform: rotate(-90deg);\n}\n\n.header__socials a:hover {\n  color: #e9c675;\n}\n\n.about {\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #0a1e27 8rem);\n  overflow: hidden;\n}\n\n.about__container {\n  padding-top: 0;\n  display: grid;\n  gap: 5rem 2rem;\n  overflow: hidden;\n}\n\n.about__image img {\n  max-width: 400px;\n  margin-inline: auto;\n  border-radius: 5px;\n  box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.4);\n}\n\n.about__content-1 .section__subheader::after {\n  content: \"D1\";\n}\n\n.about__content-2 .section__subheader::after {\n  content: \"D2\";\n}\n\n.about__content-3 .section__subheader::after {\n  content: \"D3\";\n}\n.about__content-4 .section__subheader::after {\n  content: \"D4\";\n}\n.about__content-5 .section__subheader::after {\n  content: \"D5\";\n}\n.about__content-6 .section__subheader::after {\n  content: \"D6\";\n}\n.about__content-7 .section__subheader::after {\n  content: \"07\";\n}\n.about__content-8 .section__subheader::after {\n  content: \"08\";\n}\n.about__content-9 .section__subheader::after {\n  content: \"09\";\n}\n.about__content-10 .section__subheader::after {\n  content: \"10\";\n}\n\n.about__content p {\n  margin-bottom: 1.5rem;\n  color: #cbd5e1;\n}\n\n.about__content a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #e9c675;\n}\n\n.about__content a span {\n  transition: 0.3s;\n}\n\n.about__content a:hover span {\n  transform: translateX(10px);\n}\n\n.footer {\n  background-color: var(--yellow);\n}\n\n.footer__container {\n  display: grid;\n  gap: 4rem 2rem;\n}\n\n.footer__col:first-child {\n  max-width: 300px;\n}\n\n.footer__logo {\n  margin-bottom: 1rem;\n}\n\n.footer__col p {\n  color: #cbd5e1;\n}\n\n.footer__col h4 {\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #e9c675;\n}\n\n.footer__links {\n  list-style: none;\n  display: grid;\n  gap: 1rem;\n}\n\n.footer__links a {\n  color: #cbd5e1;\n}\n\n.footer__links a:hover {\n  color: #e9c675;\n}\n\n.footer__bar {\n  padding: 1rem;\n  font-size: 0.9rem;\n  color: #cbd5e1;\n  text-align: center;\n}\n\n@media (width > 768px) {\n  .nav__logo {\n    flex: 1;\n  }\n\n  .nav__links {\n    position: static;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    background-color: transparent;\n  }\n\n  .nav__menu__btn {\n    display: none;\n  }\n\n  .nav__action__btn {\n    justify-content: flex-end;\n    display: flex;\n    flex: 1;\n  }\n\n  .header__container {\n    height: calc(100% - 10rem);\n  }\n\n  .header__socials {\n    display: flex;\n  }\n\n  .about__container {\n    grid-template-columns: repeat(2, 1fr);\n    align-items: center;\n    gap: 10rem 2rem;\n  }\n\n  .about__image-1 {\n    grid-area: 1/2/2/3;\n  }\n\n  .about__image-3 {\n    grid-area: 3/2/4/3;\n  }\n\n  .about__image-5 {\n    grid-area: 5/2/6/3;\n  }\n\n  .about__image-7 {\n    grid-area: 7/2/8/3;\n  }\n\n  .about__content {\n    margin-left: 6rem;\n  }\n\n  .footer__container {\n    grid-template-columns: 2fr 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
